import React, { Component } from "react";

class SectionRH extends Component {
  render() {
    return (
      <section className="wpo-hero-section-1 mb-section-2">
        <div className="container">
          <div className="row">
            <div className="col col-xs-7 col-lg-7 mbSection">
              <div className="wpo-hero-section-text">
                <div className="wpo-hero-title">
                  <h2 className="text-white">
                    Pronto para transformar a gestão de pessoas da sua empresa?
                  </h2>
                </div>
                <div className="wpo-hero-subtitle">
                  <p className="text-white">
                    Conte com a experiência da Thomas Talent RH para{" "}
                    <strong>impulsionar resultados</strong> com soluções
                    estratégicas e personalizadas. Estamos prontos para ser o
                    seu parceiro em Recursos Humanos.
                  </p>
                </div>
                <div className="btns justify-content-center d-flex">
                  <a
                    href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                    target="_blank"
                    rel="noreferrer"
                    className="btn theme-btn w-100"
                  >
                    Fale conosco
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-img-sectionRH"></div>
      </section>
    );
  }
}

export default SectionRH;

